export default __webpack_public_path__ + "static/media/w.209ca5bd.mp3";